import { useState, useEffect } from 'react';
import { getExpertSubscriptionStatus } from '@/services/expert-payment.service';
import { ExpertSubscriptionStatus } from '@/types/payment';
import { useAuth } from '@/hooks/useAuth';

interface UseExpertPlanResult {
  subscription: ExpertSubscriptionStatus | null;
  loading: boolean;
  hasFeature: (feature: string) => boolean;
}

export const useExpertPlan = (): UseExpertPlanResult => {
  const { user } = useAuth();
  const isExpert = (user?.roles || []).some((r: string) => r.toLowerCase() === 'expert');

  const [subscription, setSubscription] = useState<ExpertSubscriptionStatus | null>(null);
  const [loading, setLoading] = useState(isExpert);

  useEffect(() => {
    if (!isExpert) return;

    setLoading(true);
    getExpertSubscriptionStatus()
      .then(setSubscription)
      .catch(() => setSubscription({ isActive: false, status: 'none', plan: null, planCode: null, featureAccess: {} }))
      .finally(() => setLoading(false));
  }, [isExpert]);

  const hasFeature = (feature: string): boolean => {
    if (!isExpert) return true;
    return subscription?.featureAccess?.[feature] === true;
  };

  return { subscription, loading: isExpert ? loading : false, hasFeature };
};
